"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  var finalCls = '';

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(function (cls) {
    if (cls) finalCls += cls + ' ';
  });
  return finalCls;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@z-r/calendar/lib/util/classnames.js
// module id = 1217
// module chunks = 6 7 17 18